import instanceQuery from '../../queries/purchases/PurchaseOrderReceiptQuery.graphql';
import receiptResponseQuery from '../../queries/purchases/PurchaseOrderReceiptResponseQuery.graphql';
import mutationQuery from '../../mutations/purchases/PurchaseOrderReceiptMutation.graphql';
import { EntityType } from '../../../@types/entityTypes';
import { DocumentNode } from 'graphql';

export enum PurchaseReceiptAction {
  Receive = 'PURCHASE_RECEIPT_RECEIVE',
  AutoReceive = 'PURCHASE_RECEIPT_AUTO_RECEIVE',
}

const PurchaseOrderReceipt: EntityType & { receiptResponse: DocumentNode } = {
  type: 'PurchaseOrderReceipt',
  title: 'Purchase Order Receipt',
  formTitle: 'Purchase Order Receipt',
  formUrl: '/Purchasing/Receipt/Details/',
  instance: instanceQuery,
  update: mutationQuery,
  permissionLabel: 'Receive Stock',
  screenReference: 'PURCHASE_RECEIPT',
  receiptResponse: receiptResponseQuery,
  actions: [{ actionReference: PurchaseReceiptAction.Receive }, { actionReference: PurchaseReceiptAction.AutoReceive }],
};

export default PurchaseOrderReceipt;
